var map = {
	"./dashboard-image": 160,
	"./dashboard-image.png": 160,
	"./icons/back-arrow": 161,
	"./icons/back-arrow.svg": 161,
	"./icons/close_search": 162,
	"./icons/close_search.svg": 162,
	"./icons/down-arrow-transparent": 163,
	"./icons/down-arrow-transparent.svg": 163,
	"./icons/external-arrow": 164,
	"./icons/external-arrow.svg": 164,
	"./icons/logo": 165,
	"./icons/logo.svg": 165,
	"./icons/search": 166,
	"./icons/search.svg": 166,
	"./icons/side-menu-arrow": 167,
	"./icons/side-menu-arrow.svg": 167,
	"./icons/table-next": 168,
	"./icons/table-next.svg": 168,
	"./icons/table-previous": 169,
	"./icons/table-previous.svg": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;